// extracted by mini-css-extract-plugin
export default {"labelsContainer":"styles_labelsContainer__vrTP8","allLabels":"styles_allLabels__NzGCq","label":"styles_label__AWF8l","ellipses":"styles_ellipses__t2vDX"};